/* list-item.tsx generated by @compiled/babel-plugin v0.29.1 */
import "./list-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
var styles = {
  root: "_2mzuglyw _18s8ze3t"
};
function _ListItem(_ref, ref) {
  var children = _ref.children,
    xcss = _ref.xcss;
  return /*#__PURE__*/React.createElement("div", {
    role: "listitem",
    ref: ref,
    className: ax([styles.root, xcss])
  }, children);
}

/**
 * __List item__
 *
 * A [list item](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/li) with visual styles removed.
 */
export var ListItem = /*#__PURE__*/forwardRef(_ListItem);